(ns app.front.view.payment.checkout-v2
  (:require [app.front.view.payment.checkout :as checkout]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-payment-context
  (fn [_ [_ payment-id]]
    {:dispatch [:comm/command-monitored
                {:command    :payment/get-payment-context
                 :method     :get
                 :data       {:payment-id payment-id}
                 :on-success [::fetch-payment-context.success]}]}))

(rf/reg-event-fx ::fetch-payment-context.success
  (fn [{:keys [db]} [_ _ {:keys [transaction-details]}]]
    {:db (assoc db ::transaction-details transaction-details)
     :fx (checkout/payment-service-effects transaction-details)}))

(rf/reg-sub ::transaction-details :-> ::transaction-details)

(defn view [match]
  (if (<sub [:comm/command-processing? :admin/get-authority-groups])
    (cc/loading-spinner)
    (let [transaction-details (<sub [::transaction-details])
          workspace-id        (-> match :parameters :path :workspace-id)
          escrow-account      (-> match :parameters :path :account-id)]
      (when transaction-details
        [checkout/payment-form (-> transaction-details
                                   (p/assoc-if :workspace-id workspace-id
                                               :escrow-account escrow-account))]))))

(def checkout-route
  {:view          view
   :own-layout?   true
   :plain-header? true
   :hide-footer?  true
   :controllers   [{:parameters {:path [:payment-id]}
                    :start      (fn [{{:keys [payment-id]} :path}]
                                  (>evt [::fetch-payment-context payment-id]))}]})

(def route
  (merge checkout-route
         {:name :view/payment-checkout-v2}))

(def route-escrow
  (merge checkout-route
         {:name :view/payment-checkout-escrow-v2}))
